import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { PROPERTY } from "@/data/property";
import SectionHeader from "@/components/SectionHeader";

function EmbedModal({ onClose }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] flex flex-col bg-black/95 p-4 backdrop-blur-sm"
    >
      <div className="flex items-center justify-between py-2">
        <p className="text-xs uppercase tracking-[0.25em] text-white/70">
          Official iGuide Walkthrough — 52-461 Beechwood Place
        </p>
        <button
          data-testid="matterport-close-button"
          aria-label="Close walkthrough"
          onClick={onClose}
          className="rounded-full border border-white/30 p-2 text-white transition-colors duration-200 hover:bg-white/10"
        >
          <X size={20} />
        </button>
      </div>
      <iframe
        title="461 Beechwood iGuide Walkthrough"
        src={PROPERTY.tourEmbedUrl}
        allow="fullscreen"
        allowFullScreen
        className="mt-2 h-full w-full flex-1 rounded-2xl border border-white/10"
      />
    </motion.div>
  );
}

export default function Tour360() {
  const [embedOpen, setEmbedOpen] = useState(false);

  return (
    <section
      id="tour"
      data-testid="3d-tour-floorplans-section"
      className="bg-[#F4F4F3] py-20 dark:bg-[#101114] sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHeader
            eyebrow="3D Tour"
            title="Walk the rooms, room by room"
            sub="Launch the official iGuide walkthrough — drag inside to float through every room in 3D, then browse the plans below."
          />
          <button
            data-testid="launch-matterport-button"
            onClick={() => setEmbedOpen(true)}
            className="mb-12 rounded-full bg-zinc-900 px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:bg-bronze dark:bg-white dark:text-black dark:hover:bg-bronze dark:hover:text-white"
          >
            Launch iGuide Walkthrough
          </button>
        </div>

        <FloorPlans />
      </div>

      <AnimatePresence>{embedOpen && <EmbedModal onClose={() => setEmbedOpen(false)} />}</AnimatePresence>
    </section>
  );
}

import FloorPlans from "@/components/FloorPlans";
